{
  "$schema": "https://zam.app/schemas/v1/kvt-tile.json",
  "tile_id": "de-by:realschule-10-mathematik-ebene-vektorgeometrie",
  "version": "2026.08.1",
  "title": "Mathematik 10: Ebene Vektorgeometrie und Skalarprodukt (Realschule 10 Bayern)",
  "description": "Geerdetes KVT-Paket für Realschule Bayern Mathematik 10 (Abschlussprüfung): Vektorbegriff, Vektoraddition, Skalarprodukt, Orthogonalität, Determinanten-Flächenformel und Vektordrehung.",
  "publisher": "ZAM Curriculum Working Group",
  "published_at": "2026-08-15T22:30:00Z",
  "sources": [
    {
      "uri": "https://www.lehrplanplus.bayern.de/fachlehrplan/realschule/10/mathematik/wpfg1",
      "checked": "2026-08-15",
      "label": "Realschule Mathematik 10 (I), Lernbereich Ebene Vektorgeometrie"
    }
  ],
  "atoms": [
    {
      "id": "01K4V0M0000000000000000A01",
      "atom_uri": "urn:zam:atom:01K4V0M0000000000000000A01",
      "namespace": "mathematik-vektorgeometrie",
      "slug": "vektorbegriff-komponenten-betrag",
      "title": "Vektorbegriff: Koordinaten, Gegenvektor und Vektorbetrag",
      "domain": "schule/mathematik/geometrie",
      "reduction": "formal",
      "typical_age_min": 15.0,
      "prerequisites": [],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q44528",
          "target_label": "Euclidean vector",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 10,
          "track": "I",
          "subject": "mathematik",
          "topic_code": "lb1",
          "topic_title": "Ebene Vektorgeometrie",
          "exam_relevant": true
        },
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 10,
          "track": "II_III",
          "subject": "mathematik",
          "topic_code": "lb1",
          "topic_title": "Ebene Vektorgeometrie",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4V0M0000000000000000J01",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "Wie berechnet man den Betrag (die Länge) des zweidimensionalen Vektors v = (3, 4)^T?",
          "concept": "|v| = sqrt(3^2 + 4^2) = sqrt(9 + 16) = sqrt(25) = 5 LE",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "5 Längeneinheiten",
              "7 Längeneinheiten"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4V0M0000000000000000J02",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Definiere den Verbindungsvektor AB zweier Punkte A(x_A | y_A) und B(x_B | y_B) nach der 'Spitze-minus-Schaft'-Regel, bestimme für A(-2 | 3) und B(4 | -5) den Vektor AB sowie dessen Gegenvektor BA und berechne die exakte Länge der Strecke [AB].",
          "concept": "AB = B - A = (4 - (-2), -5 - 3)^T = (6, -8)^T; Gegenvektor BA = -AB = (-6, 8)^T; |AB| = sqrt(6^2 + (-8)^2) = sqrt(36 + 64) = sqrt(100) = 10 LE",
          "sample_solution": "1. Spitze-minus-Schaft-Regel: Der Verbindungsvektor AB vom Anfangspunkt A (Schaft) zum Endpunkt B (Spitze) berechnet sich durch Koordinatensubtraktion: AB = (x_B - x_A, y_B - y_A)^T. 2. Berechnung für A(-2 | 3) und B(4 | -5): AB = (4 - (-2), -5 - 3)^T = (6, -8)^T. 3. Gegenvektor BA: BA = -AB = (-6, 8)^T. 4. Länge (Betrag): |AB| = sqrt(6^2 + (-8)^2) = sqrt(36 + 64) = sqrt(100) = 10 Längeneinheiten."
        }
      ]
    },
    {
      "id": "01K4V0M0000000000000000A02",
      "atom_uri": "urn:zam:atom:01K4V0M0000000000000000A02",
      "namespace": "mathematik-vektorgeometrie",
      "slug": "skalarprodukt-orthogonalitaet-schnittwinkel",
      "title": "Das Skalarprodukt: Orthogonalitätskriterium und Winkelberechnung",
      "domain": "schule/mathematik/geometrie",
      "reduction": "formal",
      "typical_age_min": 15.0,
      "prerequisites": [
        {
          "atom_id": "01K4V0M0000000000000000A01",
          "type": "hard",
          "rationale": "Vektorkoordinaten und Vektorbetrag sind Voraussetzung für das Skalarprodukt."
        }
      ],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q181365",
          "target_label": "Dot product",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 10,
          "track": "I",
          "subject": "mathematik",
          "topic_code": "lb1",
          "topic_title": "Ebene Vektorgeometrie",
          "exam_relevant": true
        },
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 10,
          "track": "II_III",
          "subject": "mathematik",
          "topic_code": "lb1",
          "topic_title": "Ebene Vektorgeometrie",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4V0M0000000000000000J03",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "Welche Bedingung muss für das Skalarprodukt a · b zweier vom Nullvektor verschiedener Vektoren gelten, damit sie zueinander orthogonal (senkrecht) stehen?",
          "concept": "Das Skalarprodukt muss gleich 0 sein (a · b = 0)",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "a · b = 0",
              "a · b = 1"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4V0M0000000000000000J04",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Berechne das Skalarprodukt der Vektoren a = (2, 3)^T und b = (6, -4)^T, folgere daraus ihre geometrische Lagebeziehung und berechne den Schnittwinkel zwischen den Vektoren u = (1, 0)^T und v = (1, 1)^T mit der Kosinusformel cos(alpha) = (u · v) / (|u| · |v|).",
          "concept": "a · b = 2*6 + 3*(-4) = 12 - 12 = 0 -> orthogonal (90°); cos(alpha) = (1*1 + 0*1) / (1 * sqrt(2)) = 1/sqrt(2) -> alpha = 45°",
          "sample_solution": "1. Skalarprodukt von a und b: a · b = a_x · b_x + a_y · b_y = 2 · 6 + 3 · (-4) = 12 - 12 = 0. Da das Skalarprodukt gleich 0 ist, stehen die beiden Vektoren a und b senkrecht (orthogonal) aufeinander (Winkel = 90°). 2. Winkelberechnung für u und v: - Skalarprodukt: u · v = 1 · 1 + 0 · 1 = 1. - Beträge: |u| = sqrt(1^2 + 0^2) = 1; |v| = sqrt(1^2 + 1^2) = sqrt(2). - Kosinusformel: cos(alpha) = (u · v) / (|u| · |v|) = 1 / (1 · sqrt(2)) = 1/sqrt(2) = sqrt(2)/2. - Winkel: alpha = arccos(sqrt(2)/2) = 45°."
        }
      ]
    },
    {
      "id": "01K4V0M0000000000000000A03",
      "atom_uri": "urn:zam:atom:01K4V0M0000000000000000A03",
      "namespace": "mathematik-vektorgeometrie",
      "slug": "determinante-dreiecksflaeche-parallelogramm",
      "title": "Die 2x2-Determinante: Flächeninhalt von Dreiecken und Parallelogrammen",
      "domain": "schule/mathematik/geometrie",
      "reduction": "formal",
      "typical_age_min": 15.0,
      "prerequisites": [
        {
          "atom_id": "01K4V0M0000000000000000A01",
          "type": "hard",
          "rationale": "Vektorkoordinaten sind die Spalten der Determinante."
        }
      ],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q107102",
          "target_label": "Determinant",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 10,
          "track": "I",
          "subject": "mathematik",
          "topic_code": "lb1",
          "topic_title": "Ebene Vektorgeometrie",
          "exam_relevant": true
        },
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 10,
          "track": "II_III",
          "subject": "mathematik",
          "topic_code": "lb1",
          "topic_title": "Ebene Vektorgeometrie",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4V0M0000000000000000J05",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "Wie lautet die Berechnungsformel für den Wert der zweireihigen Determinante det(a, b) = | a_x  b_x | / | a_y  b_y |?",
          "concept": "Hauptdiagonale minus Nebendiagonale: a_x · b_y - a_y · b_x",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "a_x · b_y - a_y · b_x",
              "a_x · b_x + a_y · b_y"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4V0M0000000000000000J06",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Erkläre die Flächeninhaltsformel für ein Dreieck ABC im Koordinatensystem mittels Determinante A = 0.5 · |det(AB, AC)| und berechne die Fläche des Dreiecks mit A(1 | 1), B(5 | 2) und C(2 | 6), wobei auf den mathematisch positiven Umlaufsinn (gegen den Uhrzeigersinn) geachtet wird.",
          "concept": "AB = (4, 1)^T, AC = (1, 5)^T; det(AB, AC) = 4*5 - 1*1 = 20 - 1 = 19; A_Dreieck = 0.5 * 19 = 9.5 FE",
          "sample_solution": "1. Determinantenformel: Der orientierte Flächeninhalt eines von den Vektoren AB und AC aufgespannten Dreiecks beträgt A = 0,5 · det(AB, AC). Ist das Dreieck gegen den Uhrzeigersinn orientiert, ist die Determinante positiv. 2. Vektoren aufstellen: - AB = (5 - 1, 2 - 1)^T = (4, 1)^T - AC = (2 - 1, 6 - 1)^T = (1, 5)^T 3. Determinante berechnen: det(AB, AC) = | 4  1 | / | 1  5 | = (4 · 5) - (1 · 1) = 20 - 1 = 19. 4. Flächeninhalt: A_Dreieck = 0,5 · 19 = 9,5 Flächeneinheiten (FE)."
        }
      ]
    },
    {
      "id": "01K4V0M0000000000000000A04",
      "atom_uri": "urn:zam:atom:01K4V0M0000000000000000A04",
      "namespace": "mathematik-vektorgeometrie",
      "slug": "vektordrehung-abbildungsmatrix",
      "title": "Vektordrehung um den Ursprung und orthogonale Abbildungsmatrix",
      "domain": "schule/mathematik/geometrie",
      "reduction": "formal",
      "typical_age_min": 15.0,
      "prerequisites": [
        {
          "atom_id": "01K4V0M0000000000000000A01",
          "type": "hard",
          "rationale": "Vektorbegriff ist Voraussetzung für geometrische Abbildungen."
        }
      ],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q186493",
          "target_label": "Rotation matrix",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 10,
          "track": "I",
          "subject": "mathematik",
          "topic_code": "lb1",
          "topic_title": "Ebene Vektorgeometrie",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4V0M0000000000000000J07",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "Welche Koordinaten erhält man, wenn man den Vektor v = (x, y)^T um 90° gegen den Uhrzeigersinn dreht (Orthogonalvektor / Normalenvektor)?",
          "concept": "v' = (-y, x)^T",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "(-y, x)^T",
              "(y, -x)^T"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4V0M0000000000000000J08",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Gib die allgemeine Drehmatrix D_phi = [cos(phi) -sin(phi); sin(phi) cos(phi)] für eine Drehung um das Drehzentrum Z(0|0) um den Winkel phi an und berechne den Bildvektor v' bei Drehung von v = (4, 0)^T um phi = 60° gegen den Uhrzeigersinn.",
          "concept": "D_60°: cos(60°) = 0.5, sin(60°) = sqrt(3)/2; v' = (4*0.5 - 0*sin(60°), 4*sin(60°) + 0*cos(60°))^T = (2, 2*sqrt(3))^T",
          "sample_solution": "1. Allgemeine Drehmatrix: Die Drehung eines Vektors v = (x, y)^T um den Ursprung um den Drehwinkel phi lautet: x' = x · cos(phi) - y · sin(phi); y' = x · sin(phi) + y · cos(phi). 2. Berechnung für v = (4, 0)^T und phi = 60°: - Exakte trigonometrische Werte: cos(60°) = 0,5 und sin(60°) = sqrt(3)/2 ≈ 0,866. - x' = 4 · 0,5 - 0 · (sqrt(3)/2) = 2. - y' = 4 · (sqrt(3)/2) + 0 · 0,5 = 2 · sqrt(3) ≈ 3,464. - Bildvektor: v' = (2, 2·sqrt(3))^T."
        }
      ]
    }
  ]
}
